import React from 'react';
import { MessageCircle } from 'lucide-react';
import { formatWhatsAppLink } from '../utils/whatsapp';

const WhatsAppButton = () => {
  return (
    <a
      href={formatWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 group"
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle size={28} className="text-white" />
      <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-[#055509] text-white px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm font-medium shadow-lg">
        Fale Conosco
      </span>
    </a>
  );
};

export default WhatsAppButton;
